import { FORMULA_IMAGE } from "@/data/products";

export const Formula = () => {
  return (
    <section
      id="formula"
      data-testid="formula-section"
      className="relative py-24 px-6 border-b border-[var(--line)] overflow-hidden"
    >
      <img
        src={FORMULA_IMAGE}
        alt="Close-up of hydrated bare skin with fine water drops"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-[var(--bg)]/60"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <span className="label-caps text-[11px] text-[var(--ink)]/70">Label Integrity</span>
        <h2 className="serif-head text-3xl sm:text-5xl text-[var(--ink)] mt-2 mb-4">
          All-Natural Formula
        </h2>
        <p className="text-xs sm:text-sm text-[var(--ink)]/80 max-w-xl mx-auto font-light leading-relaxed mb-10">
          No harsh chemicals. Refined with pure botanical extracts and natural pheromone synergy.
        </p>

        {/* Verbatim Ingredients Label */}
        <div
          data-testid="ingredients-label"
          className="border border-[var(--ink)]/40 bg-[var(--card-bg)]/90 p-8 text-left backdrop-blur-sm"
        >
          <div className="flex items-center justify-between border-b border-[var(--line)] pb-3 mb-6">
            <span className="label-caps text-[10px] text-[var(--ink)]">
              Full Ingredient Specification
            </span>
            <span className="label-caps text-[10px] text-[var(--ink)]/60">Made in Canada</span>
          </div>
          <div className="text-xs sm:text-sm leading-relaxed text-[var(--ink)] font-light">
            <strong className="font-medium">Active Ingredients:</strong> Distilled Water,
            Witchhazel, Aloe gel, Hemp Oil, Natural Essential oils.
          </div>
          <div className="mt-6 pt-4 border-t border-[var(--line)] flex flex-wrap items-center justify-between gap-4 label-caps text-[9px] text-[var(--ink)]/70">
            <span>Usage: Shake well before use</span>
            <span>Benefit: Hydrate | Refresh | Attract</span>
            <span>Standard: Zero Harsh Chemicals</span>
          </div>
        </div>
      </div>
    </section>
  );
};
